import { httpApi } from '@api/http.api.ts';
import type { CommonSearchRequest, EmptyResultsDescription, PaginatedResponse } from '@types';

import type {
    CompletionMethod,
    PathwayCategory,
    PathwayLearningStatus,
    PathwayType,
} from '../___shared___/constants.ts';

export type { CompletionMethod, PathwayCategory, PathwayLearningStatus, PathwayType };

export interface LearningFiledsFiltersValues {
    ranks: string[];
    locations: string[];
    statuses: string[];
    methods: CompletionMethod[];
}

export interface UserAssessment {
    id: number;
    name: string;
    vessel: string;
    rank: string;
    statusDateUTC: string;
    status: string;
    scorePercent: number | null;
    certificateURL: string | null;
}

export interface UserLearning {
    title: string;
    locationName: string;
    rank: string;
    stateUpdateDateUTC: string;
    status: PathwayLearningStatus;
    score: number | null;
    scorePercent: number | null;
    resultId: number;
    hasCertificate: boolean;
    isCertificatePendingGeneration: boolean;
    pathwayVersion: string | null;
    pathwayCategory: PathwayCategory;
    pathwayType: PathwayType;
    finalQuizAttemptNumber: number | null;
    finalQuizMaxAttempts: number | null;
    completionMethod: CompletionMethod;
}

export type ResultsRequest = CommonSearchRequest;

export const getMyColumnsFiltersValues = (): Promise<LearningFiledsFiltersValues> =>
    httpApi.get<LearningFiledsFiltersValues>(`users/results/filter-list`, {}).then(({ data }) => data);

export const getMyLearningResults = (
    payload: ResultsRequest,
): Promise<PaginatedResponse<UserLearning, EmptyResultsDescription>> =>
    httpApi
        .post<PaginatedResponse<UserLearning, EmptyResultsDescription>>(`users/results/learnings`, { ...payload })
        .then(({ data }) => data);

export const getMyAssessmentResults = (
    payload: ResultsRequest,
): Promise<PaginatedResponse<UserAssessment, EmptyResultsDescription>> =>
    httpApi
        .post<PaginatedResponse<UserAssessment, EmptyResultsDescription>>(`users/results/assessments`, { ...payload })
        .then(({ data }) => data);
